/* eslint-disable @next/next/no-img-element */
import GradientContainer from "@app/components/gradient/gradient-container";

interface ProcurementItemProps {
  description: string;
}

const ProcurementItem = ({ description }: ProcurementItemProps) => (
  <div className="flex items-center space-x-4">
    <GradientContainer light overrideClassName="h-[44px] w-[4px]" />
    <p className="text-white text-body-lg sm:text-body-xl md:text-body-xl-medium">
      {description}
    </p>
  </div>
);

const ProcurementItems = [
  { key: "01", description: "Realize direct savings" },
  { key: "02", description: "Optimize deal structures" },
  { key: "03", description: "Gain best options" },
  { key: "04", description: "Strengthen market position" },
  { key: "05", description: "Automate RFP Processing" },
];

const Procurement = () => (
  <div
    className="bg-background-primary-dark-dark py-20 px-10 lg:px-20 xl:px-[120px]
  xl-2:px-[160px]">
    <h5 className="text-[#BBF7D0] text-start h5 lg:text-end md:h4 lg:h3">
      Procurement
    </h5>
    <GradientContainer overrideClassName="w-full h-1 mt-1 rounded" />
    <div className="mt-10 space-y-8 flex flex-col lg:space-y-0 lg:flex-row lg:items-start">
      <div className="space-y-8 lg:basis-1/2">
        <div>
          <h4 className="text-white mobile-h4 sm:h5 sm:pr-5 md:h4 lg:h3 md:pr-9 xl:pr-0">
            Experience the SimpleWaste Network Advantage.
          </h4>
        </div>
        <div className="space-y-4">
          {ProcurementItems.map((item) => (
            <ProcurementItem key={item.key} description={item.description} />
          ))}
        </div>
        <div className="flex w-full 3xl:pr-32 4xl:pr-64">
          <p className="hidden xl:block text-white text-body-lg text-center">
            At SimpleWaste, we procure savings in three distinct categories:
            contract pricing, facility operations, and RFP processing.
          </p>
        </div>
      </div>
      <div className="lg:basis-1/2 space-y-6">
        <img
          className="rounded"
          src="/images/platform/procurement.png"
          alt="Procurement"
        />
        <p className="text-white text-center h6 xl:h5">
          Discover your savings potential and plan options with a LIVE Demo.
        </p>
        <p className="xl:hidden text-white text-body-lg text-center">
          At SimpleWaste we procure savings in three distinct categories:
          contract pricing, facility operations, and RFP processing.
        </p>
      </div>
    </div>
  </div>
);

export default Procurement;
